import { useQuery } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { StrapiProg } from 'containers/Programmations/New/ModelePicker/types';

interface ProgModelesFilters {
  cycle: string;
  view?: 'week' | 'periode';
  subject?: string;
}

const PROG_TEMPLATES_KEY = 'progModeles';

function get(filters: ProgModelesFilters) {
  const requestURL = '/cms/programmations';
  return request(requestURL, {
    method: 'GET',
    params: { ...filters, isProgV2: true },
  }).then<StrapiProg[]>(({ data }) => data);
}

export function useProgModeles(filters: ProgModelesFilters) {
  return useQuery({
    queryKey: [PROG_TEMPLATES_KEY, JSON.stringify(filters)],
    queryFn: () => get(filters),
    placeholderData: undefined,
    staleTime: 1000 * 60 * 60,
    refetchOnWindowFocus: false,
  });
}
